import { createRouter, createWebHistory } from 'vue-router';
import { SET_SIDEBAR_EXPANDED } from '../store/action-types';
import store from '../store/store';
import routes from './routes';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach(async (to) => {
  store.dispatch(SET_SIDEBAR_EXPANDED, false);
  document.title = to.meta.title as string;
});

router.beforeEach(async (to, from, next) => {
  const requiresPlant = to.matched.some((record) => record.meta.requiresPlant);

  if (requiresPlant && !to.params.plantId ) {
    next('/');
  } else {
    next();
  }
});

export default router;
